import { jsx as _jsx, jsxs as _jsxs } from "@redneckz/uni-jsx/jsx-runtime";
import { JSX } from '@redneckz/uni-jsx';
import { useEffect } from '@redneckz/uni-jsx/lib/hooks';
import { style } from '../../utils/style.js';
import { ScrollLeftButton, ScrollRightButton } from '../LinkButton/ArrowButton.js';
import { SwipeListContainer } from '../SwipeListControl/SwipeListContainer.js';
import { useSwipeListScroll } from '../SwipeListControl/useSwipeListScroll.js';
import { renderTab } from './renderTab.js';
const scrollButtonStyle = 'hidden sm:flex absolute z-40';
const scrollStyle = {
    default: {
        item: 'flex-1',
        gap: 0,
        buttonTop: 'top-0',
    },
    animated: {
        item: 'flex',
        gap: 8,
        buttonTop: 'top-5',
    },
    underlined: {
        item: '',
        gap: 0,
        buttonTop: 'top-0',
    },
};
export const ScrollableTabsControl = JSX(({ className, items = [], activeItem, onChange, tabsType = 'default' }) => {
    const [containerRef, scroll] = useSwipeListScroll({
        itemCount: items?.length || 0,
    });
    useEffect(() => scrollToSelected(containerRef.current, items, activeItem), []);
    return (_jsxs("div", { className: style('relative overflow-x-auto no-scrollbar', className), children: [_jsx(SwipeListContainer, { containerRef: containerRef, snapAlign: "snap-start", onVisibleIndicesChange: scroll.handleVisibleIndicesChange, itemClassName: scrollStyle[tabsType].item, gap: scrollStyle[tabsType].gap, children: items.map(renderTab(activeItem, onChange, tabsType)) }), scroll.canScrollLeft ? (_jsx(ScrollLeftButton, { className: style('left-6', scrollButtonStyle, scrollStyle[tabsType].buttonTop), onClick: scroll.scrollLeft })) : null, scroll.canScrollRight ? (_jsx(ScrollRightButton, { className: style('right-6', scrollButtonStyle, scrollStyle[tabsType].buttonTop), onClick: scroll.scrollRight })) : null] }));
});
const scrollToSelected = (container, items, activeItem) => {
    const selectedIndex = items.findIndex((_) => _ === activeItem);
    if (container && selectedIndex > 0) {
        container.scrollTo({
            left: container?.children[selectedIndex]?.offsetLeft,
            behavior: 'smooth',
        });
    }
};
//# sourceMappingURL=ScrollableTabsControl.js.map